var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.center ? 'text-xs-center': ''},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }